import 'jquery-ui';
require('jquery-ui/ui/widgets/autocomplete.js');
import * as bootstrap from 'bootstrap';

jQuery(function ($) {
    let url = $("#zip").attr("data-url");
    $('#zip').autocomplete({
        source: function (req, response) {
            $.get(
                url+'?action=zip_search',
                req,
                response,
                'json'
            )
        },
        delay: 300,
        minLength: 3
    });

    let adresse_autocomplete_url = $('#adresse').attr('data-url');
    let zip = $('#adresse').attr('data-zip');
    $('#adresse').autocomplete({
        source: function (req, response) {
            $.get(
                adresse_autocomplete_url + '?action=adresse_search&zip=' + zip,
                req,
                response,
                'json'
            )
        },
        delay: 500,
        minLength: 3,
    });

    $(document).on('submit', 'form.step-recap', function (event) {
        $('button#final-submit').prop('disabled', true);
    });
    
    $('.hide-relative').click((event) => {
        const relative = $($(event.target).attr('data-relative'));
        if (relative.attr('hidden') === 'hidden') {
            relative.removeAttr('hidden');
        } else {
            relative.attr('hidden', '');
        }
    });

    $('#has_logements_supplementaire').change(function () {
        if ($(this).is(':checked')) {
            $('#row_logements_supp').removeAttr('hidden');
        } else {
            $('#row_logements_supp').attr('hidden', '');
            $('#nbr_maisons_supplementaires').val('0');
            $('#nbr_appart_supplementaires').val('0');
        }
    });

    if ($('.full-address-autocomplete').length > 0) {
        $('.full-address-autocomplete').each((index, element) => {
            const zipInput = $($(element).attr('data-zip'));
            const communeInput = $($(element).attr('data-commune'));

            $(element).autocomplete({
                source: (req, response) => {
                    $.get(
                        adresse_autocomplete_url + '?action=adresse_search&zip=' + zipInput.val() + '&fullAuto=true',
                        req,
                        response,
                        'json'
                    )
                },
                delai: 500,
                minLength: 4,
                select: function (event, ui) {
                    zipInput.val(ui.item.zip);
                    communeInput.val(ui.item.commune);
                }
            });
        });
    }
});
